import React, { useState, useEffect, useContext } from "react";
import { useNavigate } from "react-router-dom";
import { AuthContext } from "../AuthContext";
import LoadingComponent from "./loading";

const API_BASE = process.env.REACT_APP_API_BASE_URL || 'https://api.insightos.co.uk';

export default function Logout() {
  const navigate = useNavigate();
  const auth = useContext(AuthContext);
  
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const performLogout = async () => {
      setLoading(true);
      try {
        const response = await fetch(`${API_BASE}/leads/logout`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          credentials: 'include',
        });

        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
      } catch (error) {
        console.error("Error logging out:", error);
      } finally {
        if (typeof sessionStorage !== 'undefined') {
          sessionStorage.removeItem('leads_auth_token');
        }
        if (auth?.logout) {
          auth.logout();
        }
        setLoading(false);
        navigate('/login', { replace: true });
      }
    };

    performLogout();
  }, [auth, navigate]);

  return <>{loading ? <LoadingComponent /> : null}</>;
}
